import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";

const TypeOfCornerGoal = ({
  GOAL_TYPES,
  eventDetails,
  setEventDetails,
  changeCallback,
  confirmCallback,
  preventChange
}) => {
  return (
    <div
      style={{
        padding: "10px 30px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          backgroundColor: "transparent",
          border: "1px solid black",
          height: 35,
          width: 35,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 20,
        }}
      >
        <Icon name="fa-arrow-circle-right" />
      </div>

      {eventDetails?.typeOfCornerGoalSelected && (
        <button
          style={{
            borderRadius: 5,
            backgroundColor:
              eventDetails?.typeOfCornerGoalSelected?.backgroundColor ||
              "white",
            border: `2px solid ${eventDetails?.typeOfCornerGoalSelected?.borderColor}`,
            color: eventDetails?.typeOfCornerGoalSelected?.color || "black",
            height: 40,
            width: "25%",
            fontWeight: 700,
            marginRight: 30,
            fontSize: 16,
          }}
        >
          <span>{eventDetails?.typeOfCornerGoalSelected?.name}</span>
        </button>
      )}

      {eventDetails?.typeOfCornerGoalSelected && !preventChange ? (
        <button
          style={{
            border: "none",
            backgroundColor: "transparent",
            fontSize: "16px",
          }}
          onClick={() => {
            setEventDetails((data) => ({
              ...data,
              typeOfCornerGoalSelected: null,
            }));
            changeCallback && changeCallback();
          }}
        >
          X
          <span
            style={{
              border: "none",
              backgroundColor: "transparent",
              fontSize: "16px",
              textDecoration: "underline",
              marginLeft: 5,
            }}
          >
            Ändern
          </span>
        </button>
      ) : null }

      {!eventDetails?.typeOfCornerGoalSelected && (
        <div
          style={{
            display: "flex",
            width: "70%",
          }}
        >
          {GOAL_TYPES?.map((tg, index) => {
            return (
              <button
                key={index}
                style={{
                  borderRadius: 5,
                  backgroundColor: tg?.backgroundColor || "white",
                  border: `2px solid ${tg?.borderColor}`,
                  color: tg?.color || "black",
                  height: 40,
                  width: "45%",
                  fontWeight: 700,
                  marginRight: 10,
                  fontSize: 16,
                }}
                onClick={() => {
                  setEventDetails((data) => ({
                    ...data,
                    typeOfCornerGoalSelected: tg,
                  }));
                  confirmCallback && confirmCallback();
                }}
              >
                {tg?.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TypeOfCornerGoal;
